import { useAsyncData, useNuxtApp } from '#imports'

import type { AlgoliaProduct } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import { toPublicPath } from '@backmarket/nuxt-layer-base/utils/toPublicPath'

const GENERATED_IMAGES_BASE_URL =
  'https://s1.statics.backmarket.com/outlet/images-generated'
const NUMBER_OF_IMAGES = 3

export type OutletDeviceType = 'iphone' | 'macbook'

export function useProductImages() {
  const nuxtApp = useNuxtApp()
  const { data, pending } = useAsyncData(
    'outlet-uuid-directory',
    () =>
      $fetch<Record<string, string>>(
        import.meta.server
          ? '/data/outlet/uuid-directory.json'
          : toPublicPath('/data/outlet/uuid-directory.json'),
      ),
    {
      default: () => ({}) as Record<string, string>,
      server: true,
      lazy: false,
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )

  const getProductImages = (algoliaProduct: AlgoliaProduct): string[] => {
    if (pending.value) {
      return []
    }

    const productId = algoliaProduct.id
    const directory = data.value[productId]

    if (directory) {
      return Array.from({ length: NUMBER_OF_IMAGES }, (_, i) => {
        return `${GENERATED_IMAGES_BASE_URL}/${directory}/${directory}--${i + 1}.png`
      })
    }

    return algoliaProduct.image1 ? [algoliaProduct.image1] : []
  }

  const getDeviceType = (
    algoliaProduct: AlgoliaProduct,
  ): OutletDeviceType | null => {
    if (pending.value) {
      return null
    }

    const directory = data.value[algoliaProduct.id]

    if (!directory) {
      return null
    }

    if (directory.startsWith('iphone-')) {
      return 'iphone'
    }

    if (directory.startsWith('macbook-')) {
      return 'macbook'
    }

    return null
  }

  return { getProductImages, getDeviceType }
}
